import React from "react";
import direction from "../../../service/direction.json";
const BuyCouldPhone = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-6">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              خرید تلفن ثابت ابری از پیش شماره استان دلخواه
            </h5>
            <p className="card-text">
              با توجه به اینکه این امکانات یک سرویس مجازی میباشد پس شما بدون
              توجه به شهر محل سکونت خود، میتوانید تلفن ثابت مجازی از پیش شماره
              هر شهر دلخواه دیگر ثبت نام و تهیه کنید. فرض کنید شما ساکن نیشابور
              خراسان هستید میتوانید تلفن ثابت با پیش شماره 021 تهران تهیه کنید.
              و یا برعکس ساکن تهران هستید ولی تلفن ثابت با پیش شماره 041 تبریز
              تهیه کنید.
              <br />
              این قابلیت برای کسانیکه کسب و کارشان در شهرستان است ولی مایلند خود
              را بعنوان یک کسب و کار در پایتخت نشان دهند بسیار کاربردی است و
              براحتی میتوانند خط تلفن ثابت با کد 021 تهیه کنند.
            </p>
            <div className="text-center">
              اگر قبلا از سایه بان پنل پیامک دارید، نیازی به ثبت نام جدید نیست و
              منوی تلفن ابری در همان پنل موجود میباشد. در غیر این صورت با یک
              عضویت در هر کدام از بسته ها شما میتوانید یک پنل دریافت کنید و هم
              از سامانه پیامک استفاده کنید و هم از تلفن ابری و تلفن ابری در همه
              بسته ها موجود میباشد.
              <br />
              <a
                href="http://sms.sayyehban.ir/register.jspd"
                className="btn btn-info"
              >
                فرم خرید تلفن ثابت ابری
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className=" row col-md-6 text-center">
        <img src={`${direction.ImgDesign}iran-all-state.png`} alt="سایه بان" />
        <img
          src={`${direction.ImgDesign}voip-register.png`}
          style={{ width: "600px", height: "600px" }}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default BuyCouldPhone;
